import paths from "../nav/paths";
export default paths;
